import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { DialogFocusDirective } from './dialog-focus.directive';
import { IconComponent } from './icon.component';
import { KEYBOARD_SHORTCUTS } from '@sharedlib/sheets-editor/keyboard-shortcuts';
import { SHEETS_STRINGS } from '@sharedlib/sheets-editor/sheets.strings';

/** §11.6.1's "Keyboard shortcuts": Appendix F S-40's list, each entry a key that works. */
@Component({
  selector: 'app-shortcuts-dialog',
  standalone: true,
  imports: [IconComponent, DialogFocusDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shortcuts-dialog.component.html',
  styleUrls: ['./shortcuts-dialog.component.less', './sheets-buttons.css'],
})
export class ShortcutsDialogComponent {
  /** NFR-8: Appendix F's strings, from their one definition. */
  protected readonly S = SHEETS_STRINGS;
  @Output() public readonly closed = new EventEmitter<void>();
  protected readonly shortcuts = KEYBOARD_SHORTCUTS;
}
